import { render } from "./FormSetting.vue?vue&type=template&id=163e8d51"
import script from "./FormSetting.vue?vue&type=script&lang=js"
export * from "./FormSetting.vue?vue&type=script&lang=js"
script.render = render

export default script